module.exports = "var appState = {\r\n  currentUser: {\r\n    id: 12,\r\n    // .... more user data\r\n  }\r\n}\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/appFailingState.html
 ** module id = 274
 ** module chunks = 0
 **/